const routesPaths = {
    // ** Authentication Routes
    LOGIN: '/login',
    PRE_REGISTER: '/pre-register',
    REGISTER: '/register',
    ACTIVATE_USER: '/verify-email',

    // ** Callback
    AUTHENTICATION_LOGIN_CALLBACK: '/Authentication/Login/Callback',
    AUTHENTICATION_LOGIN_ERROR_CALLBACK: '/Authentication/Login/Error',


    // ** Gp Portal
    GP_PORTAL: '/GP-Portal/:pageType',

    // ** Invitation
    Invitation: '/Invitation',

    // ** Upload Documents
    UploadDocuments: '/UploadDocuments',
};

export default routesPaths;
